import styled from 'styled-components';

export const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  & > div {
    margin-bottom: 0;
  }
`;

export const FieldLabel = styled.label`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.midGrey};
`;

/** The Input component is single-line only; message and description need room. */
export const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  min-height: 5.5rem;
  resize: vertical;
  padding: 0.75rem 0.9rem;
  border: 1px solid ${({ theme }) => theme.grey};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.dark};
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.5;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.midGrey};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.lightGrey};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FieldFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.midGrey};
`;

export const CharCount = styled.span<{ $over: boolean }>`
  margin-left: auto;
  color: ${({ theme, $over }) => ($over ? theme.negative : theme.midGrey)};
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.dark};
  cursor: pointer;

  input {
    margin-top: 0.15rem;
    flex-shrink: 0;
  }
`;

export const Callout = styled.p<{ $tone?: 'warning' }>`
  margin: 0;
  padding: 0.75rem 0.9rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme, $tone }) => ($tone === 'warning' ? theme.middle : theme.grey)};
  background: ${({ theme }) => theme.lightGrey};
  font-size: 0.8125rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.dark};
`;
